/**
 * ADR-0006: warn (do not block) when saving/updating a filter that has both a
 * point-in-time date and one or more user groups.
 */
export function shouldWarnSavedFilterPointInTimeWithUserGroups(args: {
  pointInTimeDate?: string | null;
  userGroupIds?: number[] | null;
}): boolean {
  const pit = args.pointInTimeDate?.trim() ?? "";
  if (pit.length === 0) {
    return false;
  }
  return (args.userGroupIds?.length ?? 0) > 0;
}
